<template>
  <div class="msg-list">
    <iframe
      :src="$getOldWebUrl()+src"
      frameborder="0"
      height="100%"
      scrolling="auto"
      style="position:absolute;top: 20px;left: 0px;"
      width="100%"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'Chat',
  componentName: "Chat",
  data () {
    return {
      src: 'chat/chat.jsp',
    }
  },
  created () {
    let to = this.$route.query.to
    if (to) {
      this.src += '?to=' + to
    }
  },
  methods: {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/common/msgList.vue